import React, { useState, useRef, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
// import 'react-pdf/dist/esm/Page/TextLayer.css';
import escapeRegExp from 'escape-string-regexp';
import Grid from '@material-ui/core/Grid';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    width: '1200px',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    maxHeight: '600px',
    overflowY: 'scroll',
};

export default function PdfRender({ handleClose, open, data }) {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [commentedDoc, setCommentedDoc] = useState([]);
    const [annotations, setannotations] = useState([]);

    const loadCommentedDoc = () => {
        const sentenceNodes = document.querySelectorAll('.react-pdf__Document'); // Replace with appropriate selector for sentence nodes

        const comments = JSON.parse(commentedDoc.incorporation_document_commented);
        console.log(comments);
        if (comments) {
            setTimeout(() => {
                sentenceNodes.forEach((node) => {
                    if (node.querySelector('.react-pdf__Page__textContent')) {
                        const containers = node.querySelectorAll('.react-pdf__Page__textContent');
                        containers.forEach((container) => {
                            comments &&
                                comments.forEach((text) => {
                                    // console.log(text.selectedTextArray);
                                    text.selectedTextArray.forEach((t) => {
                                        let escapedSentence;
                                        if (text.sentence) {
                                            escapedSentence = escapeRegExp(text.sentence);
                                        } else {
                                            escapedSentence = escapeRegExp(t);
                                        }

                                        const regex = new RegExp(`(${escapedSentence})(?![^<>]*>)`, 'gi');
                                        const matches = container.innerHTML.match(regex);

                                        if (matches) {
                                            console.log(matches);
                                            matches.forEach((matchText) => {
                                                if (matchText.length > 1) {
                                                    const highlightedContent = matchText.replace(
                                                        new RegExp(`(${escapedSentence})(?![^<>]*>)`, 'gi'),
                                                        `<span style="background-color: yellow;opacity:0.3">$1</span>`
                                                    );

                                                    container.innerHTML = container.innerHTML.replace(
                                                        new RegExp(`(${escapedSentence})(?![^<>]*>)`, 'gi'),
                                                        highlightedContent
                                                    );
                                                }
                                            });
                                        }

                                        // const regex = new RegExp(
                                        //   `\\b(${escapedSentence.replace(
                                        //     /[.*+\-?^${}()|[\]\\]/g,
                                        //     "\\$&"
                                        //   )})\\b`,
                                        //   "gi"
                                        // );

                                        // container.innerHTML = container.innerHTML
                                        //   .split(/(<[^>]+>)/) // Split by HTML tags
                                        //   .map((text) => {
                                        //     if (text.startsWith("<")) return text; // Skip HTML tags
                                        //     return text.replace(
                                        //       regex,
                                        //       `<span style="background-color: yellow;">$&</span>`
                                        //     );
                                        //   })
                                        //   .join("");
                                    });
                                });
                        });
                    }
                });
            }, 1000);
        }

        // setAnnotations(comments);
    };

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        loadCommentedDoc();
    }

    useEffect(() => {
        setCommentedDoc(data);
        if (data?.incorporation_document_commented) {
            setannotations(JSON.parse(data.incorporation_document_commented));
        }
    }, [commentedDoc]);

    return (
        <div>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Grid item xs={12} sm={7}>
                        <Document
                            file={commentedDoc?.incorporation_document} // Replace with the path to your PDF file
                            onLoadSuccess={onDocumentLoadSuccess}
                        >
                            {/* <Page pageNumber={pageNumber} onClick={handleTextSelection}></Page> */}
                            {Array.from(new Array(numPages), (el, index) => (
                                <Page key={`page_${index + 1}`} pageNumber={index + 1} scale="1.2" />
                            ))}
                        </Document>
                    </Grid>
                    <Grid item xs={12} sm={1}></Grid>
                    <Grid item xs={12} sm={4}>
                        {annotations &&
                            annotations.map((annotation, index) => {
                                return (
                                    <>
                                        {annotation.comment && (
                                            <div
                                                key={index}
                                                className="mt-3"
                                                style={{
                                                    borderBottom: '1px solid #d9d9d9',
                                                    paddingBottom: '10px',
                                                }}
                                            >
                                                {/* {annotation.selectedTextArray.map((selected) => { */}
                                                {/* return ( */}
                                                <>
                                                    <h6
                                                        style={{
                                                            background: 'rgba(255,255,0,0.3',
                                                            display: 'block',
                                                        }}
                                                    >
                                                        <strong>{annotation?.selectedTextArray?.join(' ')}</strong>
                                                    </h6>
                                                    <small> - {JSON.stringify(annotation.comment)}</small>
                                                </>
                                                {/* ); */}
                                                {/* })} */}
                                            </div>
                                        )}
                                    </>
                                );
                            })}
                    </Grid>
                </Box>
            </Modal>
        </div>
    );
}
